import type { TOC } from '@ember/component/template-only';
import t from 'ember-intl/helpers/t';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default <template>
  {{#if @forcComponent.changeset.eyeSymptoms}}
    <@form.FieldsRadioGroup
      @propertyName='eyeSymptomsRedEye'
      @title={{t 'mici-form.eyeSymptomsRedEye.long' htmlSafe=true}}
      as |Group|
    >
      <Group.FieldRadio @value={{true}} @label='Oui' />
      <Group.FieldRadio @value={{false}} @label='Non' />
    </@form.FieldsRadioGroup>
  {{/if}}
</template> satisfies TOC<Signature>;
